export default import.meta.ROLLDOWN_FILE_URL_AvT4Q3cpxMkYTQqTzr1jgQ